/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  MythNFTManager,
  MythNFTManagerInterface,
} from "../MythNFTManager";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint16[]",
        name: "nftTypeId",
        type: "uint16[]",
      },
      {
        indexed: false,
        internalType: "uint8[]",
        name: "rarity",
        type: "uint8[]",
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "name",
        type: "string[]",
      },
    ],
    name: "NFTTypeCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "nftTypeId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "buyNum",
        type: "uint16",
      },
    ],
    name: "buyNFT",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "nftTypeId",
        type: "uint16",
      },
    ],
    name: "checkPassAndClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "root",
        type: "bytes32",
      },
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]",
      },
    ],
    name: "checkWhitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "uint16[]",
        name: "nftTypeIds",
        type: "uint16[]",
      },
      {
        internalType: "uint32[]",
        name: "startTokenIds",
        type: "uint32[]",
      },
      {
        internalType: "uint32[]",
        name: "endTokenIds",
        type: "uint32[]",
      },
      {
        internalType: "uint16[]",
        name: "totalNums",
        type: "uint16[]",
      },
      {
        internalType: "uint256[]",
        name: "prices",
        type: "uint256[]",
      },
      {
        internalType: "uint8[]",
        name: "rarities",
        type: "uint8[]",
      },
      {
        internalType: "string[]",
        name: "names",
        type: "string[]",
      },
      {
        internalType: "uint8[]",
        name: "actionStatus",
        type: "uint8[]",
      },
      {
        internalType: "uint8[]",
        name: "freeTypes",
        type: "uint8[]",
      },
    ],
    name: "createNFTTypes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "nftTypeId",
        type: "uint16",
      },
    ],
    name: "freeClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "uint16[]",
        name: "nftTypeIds",
        type: "uint16[]",
      },
      {
        internalType: "bytes32[]",
        name: "roots",
        type: "bytes32[]",
      },
    ],
    name: "importWinningList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "payee_",
        type: "address",
      },
      {
        internalType: "address",
        name: "mythPassAddr_",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "themeContractAddr",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "nftTypeId",
        type: "uint16",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "themeContractAddr",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint16[]",
        name: "nftTypeIds",
        type: "uint16[]",
      },
    ],
    name: "mintBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mythPassAddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "nftClaimed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "nfts",
    outputs: [
      {
        internalType: "uint32",
        name: "tokenId",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "endTokenId",
        type: "uint32",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "rarity",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "merkelRoot",
        type: "bytes32",
      },
      {
        internalType: "uint16",
        name: "totalNum",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "soldNum",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "actionStatus",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "freeType",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "isPause",
        type: "bool",
      },
    ],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "payee",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "uint16[]",
        name: "nftTypeIds",
        type: "uint16[]",
      },
      {
        internalType: "uint8[]",
        name: "actionStatus",
        type: "uint8[]",
      },
    ],
    name: "updateActionStatus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "uint16[]",
        name: "nftTypeIds",
        type: "uint16[]",
      },
      {
        internalType: "uint8[]",
        name: "freeTypes",
        type: "uint8[]",
      },
    ],
    name: "updateFreeTypes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "mythPassAddr_",
        type: "address",
      },
    ],
    name: "updateMythPassAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "payee_",
        type: "address",
      },
    ],
    name: "updatePayee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "uint16[]",
        name: "nftTypeIds",
        type: "uint16[]",
      },
      {
        internalType: "uint256[]",
        name: "prices",
        type: "uint256[]",
      },
    ],
    name: "updatePrices",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "nftTypeId",
        type: "uint16",
      },
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]",
      },
    ],
    name: "whitelistClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type MythNFTManagerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MythNFTManagerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MythNFTManager__factory extends ContractFactory {
  constructor(...args: MythNFTManagerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MythNFTManager> {
    return super.deploy(overrides || {}) as Promise<MythNFTManager>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): MythNFTManager {
    return super.attach(address) as MythNFTManager;
  }
  connect(signer: Signer): MythNFTManager__factory {
    return super.connect(signer) as MythNFTManager__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MythNFTManagerInterface {
    return new utils.Interface(_abi) as MythNFTManagerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MythNFTManager {
    return new Contract(address, _abi, signerOrProvider) as MythNFTManager;
  }
}
